import Nav from "./../Page/Share/Nav/Nav";
const Post29 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Brand Moodboard
          </h2>
          {/* items?.Description */}
          <p>

          </p>
          {/* img section */}
          <img src="https://i.ibb.co/7RV1mSq/1.jpg" alt="" />
          <img src="https://i.ibb.co/yggMLXk/2.jpg" alt="" />
          <img src="https://i.ibb.co/QFvGrkT/3.jpg" alt="" />
          <img src="https://i.ibb.co/SJ44h4B/4.jpg" alt="" />
          <img src="https://i.ibb.co/23XrRNk/5.jpg" alt="" />
          <img src="https://i.ibb.co/cXbx9Hc/6.jpg" alt="" />
          <img src="https://i.ibb.co/zS6y7FX/7.jpg" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <img src="" alt="" />
          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post29;
